import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Icon from '@clearscore/rainbow.icons.success-inline';
import Text from '@clearscore/rainbow.text';
import toTitleCase from '@clearscore/normalize.title-case';

import styles from './checkbox.css';
import { themes, sizes } from './constants';

let uid = 0;

const Checkbox = ({ children, isDisabled, onChange, theme, checked, dataId, size, id, ...restProps }) => {
    const themeClass = styles[`isTheme${toTitleCase(theme)}`];

    const inputClass = cx(styles.input, themeClass, {
        [styles.checked]: checked,
        [styles.disabled]: isDisabled,
    });

    const tickClass = cx(styles.tick, themeClass, {
        [styles.checked]: checked,
        [styles.disabled]: isDisabled,
    });
    const labelClass = cx(styles.label, themeClass, {
        [styles.disabled]: isDisabled,
    });
    const elId = id || `checkbox${(uid += 1)}`;
    const Label = size === sizes.REGULAR ? Text.Body1 : Text.Body2;

    return (
        <label className={labelClass} htmlFor={elId} data-qa="checkbox" data-id={dataId}>
            <div>
                <input
                    type="checkbox"
                    checked={checked}
                    className={inputClass}
                    disabled={isDisabled}
                    onChange={onChange}
                    {...restProps}
                    id={elId}
                />
                <div className={styles.tickWrapper}>
                    <div className={tickClass}>
                        <Icon width={14} height={14} />
                    </div>
                </div>
            </div>

            <Label>{children}</Label>
        </label>
    );
};

Checkbox.propTypes = {
    children: PropTypes.node.isRequired,
    isDisabled: PropTypes.bool,
    name: PropTypes.string.isRequired,
    id: PropTypes.string,
    onChange: PropTypes.func,
    theme: PropTypes.oneOf(Object.values(themes)),
    size: PropTypes.oneOf(Object.values(sizes)),
    checked: PropTypes.bool,
    dataId: PropTypes.string,
};

Checkbox.defaultProps = {
    onChange: () => {},
    checked: false,
    isDisabled: false,
    theme: themes.LIGHT,
    size: sizes.REGULAR,
    dataId: undefined,
    id: undefined,
};

Checkbox.themes = themes;
Checkbox.sizes = sizes;

export default Checkbox;
